import React, { useEffect, useState } from "react";
// import "./AdminUserList.css";
// import "../../components/CommonStyle.css";
import { Button, Label } from "../StyledComp/StyledComp";
import InputField from "../StyledComp/InputField";
import DropDownLarge from "../StyledComp/DropDownLarge";
import {
  updateEmailAdminUser,
  updateFirstNameAdminUser,
  updateLastNameAdminUser,
} from "../../store/adminUserApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AdminUserService from "../../services/adminUserServices";
import { useNavigate } from "react-router-dom";
import {
  changeAdminUserScreen,
  changeCurrentConfigurationMenu,
} from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";

const AdminUserCreation: React.FC = () => {
  const createAdminBody = useSelector(
    (state: RootState) => state.adminUserApiSlice
  );
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const handleSubmit = async (event: React.FormEvent<HTMLButtonElement>) => {
    console.log("handleSubmitt");
    event.preventDefault();
    console.log(createAdminBody);
    const response = await AdminUserService.createAdminUser(createAdminBody);
    console.log("response", response);
    if (response.data.data != null) {
      alert("Details sent to created admin user");
      // navigate("/settings", { replace: true });
      dispatch(changeAdminUserScreen(screenConfig.adminUserListScreen));
      dispatch(
        changeCurrentConfigurationMenu(screenConfig.adminUserConfiguration)
      );
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      alert(response.data.errors);
      // setError(response.data.errors);
    }
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // console.log("updateInput");
    console.log(event.target.name);
    if (event.target.name == "FirstName") {
      dispatch(updateFirstNameAdminUser(event.target.value));
    } else if (event.target.name == "LastName") {
      dispatch(updateLastNameAdminUser(event.target.value));
    } else if (event.target.name == "Email") {
      dispatch(updateEmailAdminUser(event.target.value));
    }
  };

  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log("updateSelectBox");
    console.log(event.target.name);
  };

  return (
    <>
      <div className="section-box">
        <h3 className="section-heading">Create User</h3>
        <form className="form-wrapper">
          <div className="input-field-div-wrapper">
            <Label>First Name</Label>
            <input
              className="input-field-div"
              placeholder="First Name"
              id="FirstName"
              name="FirstName"
              onChange={updateInput}
            />
          </div>

          <div className="input-field-div-wrapper">
            <Label>Last Name</Label>
            <input
              className="input-field-div"
              placeholder="Last Name"
              id="LastName"
              name="LastName"
              onChange={updateInput}
            />
          </div>
          <div className="input-field-div-wrapper">
            <Label>Email ID</Label>
            <input
              className="input-field-div"
              placeholder="Email Id"
              id="Email"
              name="Email"
              onChange={updateInput}
            />
          </div>
          <select className="dropdown-control-large">
            <option disabled={true} value="">
              --Roles--
            </option>
            <option value="1">Admin</option>
          </select>
        </form>
      </div>
      <div className="submit-button-div">
        <Button type="submit" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default AdminUserCreation;
